import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { DashboardContainer } from "@/components/layout/dashboard-container"
import { Header } from "@/components/layout/header"
import { OrdersCreateOrdersTabs } from "@/components/orders/create-orders/tabs"
import { FRONTEND_ROUTES } from "@/constants"

export function CreateOrderPage() {
  const { t } = useTranslation()

  return (
    <DashboardContainer>
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              href: FRONTEND_ROUTES.ORDERS.href,
              label: t("sidebar.orders"),
            },
            {
              label: t("pages.orders.createOrder"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <h1 className="page-title">
          {t("pages.orders.createOrder")}
        </h1>
        <OrdersCreateOrdersTabs />
      </section>
    </DashboardContainer>
  )
}
